/**
 * /help/thanks — Confirmation page after report submission.
 */

import type { JSX } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ReportSubmittedCard } from '../../components/help/ReportSubmittedCard.js';

export const Route = createFileRoute('/help/thanks')({
  component: HelpThanksPage,
});

function HelpThanksPage(): JSX.Element {
  return (
    <div className="help-page" data-testid="help-thanks-page">
      <div className="help-page-inner">
        <ReportSubmittedCard />
      </div>
    </div>
  );
}
